export default __webpack_public_path__ + "static/media/construction 2.22607f1c.jpg";